// Aerator Project - BOM Seed Data
// Compatible with DFR-App-Demo

export const bomSeedData = [
    {
        id: 1,
        level: 0,
        parentId: null,
        childIds: [2, 3, 15, 19, 20],
        component: 'Handheld Milk Frother Assembly',
        partNumber: 'AERATOR-MF-2025-V17',
        description: 'Complete handheld milk frother assembly - Iteration 17',
        basicFunction: 'To froth milk and other liquids',
        quantity: 1,
        material: 'Multiple',
        manufacturingProcess: 'Assembly',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-12-12',
        linkedFmeaIds: [],
        linkedTestIds: [],
        linkedMaterialSpecIds: [],
        criticality: 'Critical',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['assembly', 'frother', 'aerator']
    },
    {
        id: 2,
        level: 1,
        parentId: 1,
        childIds: [],
        component: 'Main Housing',
        partNumber: 'MF-HSG-001-R3',
        description: 'Ergonomic ABS housing - 220mm x 35mm diameter',
        basicFunction: 'To house internal components and provide ergonomic grip',
        quantity: 1,
        material: 'ABS High-Impact',
        materialId: 'MAT-ABS-001',
        manufacturingProcess: 'Injection Molding',
        supplier: 'PlasticTech Inc',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-11-15',
        linkedFmeaIds: ['FMEA-001', 'FMEA-002'],
        linkedTestIds: ['TEST-001', 'TEST-004'],
        linkedMaterialSpecIds: ['MAT-ABS-001'],
        criticality: 'High',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['housing', 'enclosure', 'grip']
    },
    {
        id: 3,
        level: 1,
        parentId: 1,
        childIds: [4, 5, 6, 8, 9, 12, 18],
        component: 'Electrical Sub-Assembly',
        partNumber: 'MF-ELECT-SA-001',
        description: 'Motor, batteries, switch assembly',
        basicFunction: 'To provide electrical power and control',
        quantity: 1,
        material: 'Multiple',
        manufacturingProcess: 'Sub-assembly',
        isValidated: true,
        validationStatus: 'Passed',
        linkedFmeaIds: [],
        linkedTestIds: ['TEST-005', 'TEST-006'],
        linkedMaterialSpecIds: [],
        criticality: 'Critical',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['electrical', 'power', 'motor']
    },
    {
        id: 4,
        level: 2,
        parentId: 3,
        childIds: [],
        component: 'Battery Contact Spring (+)',
        partNumber: 'MF-BCS-001',
        description: 'Nickel-plated spring steel contact',
        basicFunction: 'To conduct electricity from battery positive terminal',
        quantity: 2,
        material: 'Spring Steel, Nickel Plated',
        materialId: 'MAT-STEEL-SPRING-001',
        manufacturingProcess: 'Stamping, Plating',
        supplier: 'SpringTech Co',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-10-20',
        linkedFmeaIds: ['FMEA-004'],
        linkedTestIds: ['TEST-006'],
        linkedMaterialSpecIds: ['MAT-STEEL-SPRING-001'],
        criticality: 'High',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['battery', 'contact', 'spring']
    },
    {
        id: 5,
        level: 2,
        parentId: 3,
        childIds: [],
        component: 'Battery Contact Plate (-)',
        partNumber: 'MF-BCP-001',
        description: 'Negative battery terminal contact plate',
        basicFunction: 'To conduct electricity from battery negative terminal',
        quantity: 2,
        material: 'Nickel-Plated Steel',
        materialId: 'MAT-STEEL-NI-001',
        manufacturingProcess: 'Stamping',
        supplier: 'SpringTech Co',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-10-20',
        linkedFmeaIds: ['FMEA-004'],
        linkedTestIds: ['TEST-006'],
        linkedMaterialSpecIds: ['MAT-STEEL-NI-001'],
        criticality: 'High',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['battery', 'contact', 'negative']
    },
    {
        id: 6,
        level: 2,
        parentId: 3,
        childIds: [7],
        component: 'DC Motor',
        partNumber: 'MF-MOT-HC-002',
        description: '1.5V DC motor, 15000 RPM - High capacity brushless',
        basicFunction: 'To convert electrical energy to rotational mechanical energy',
        quantity: 1,
        material: 'Steel, Copper, Neodymium',
        supplier: 'TurboMotors Ltd',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-11-01',
        linkedFmeaIds: ['FMEA-009', 'FMEA-010', 'FMEA-011'],
        linkedTestIds: ['TEST-005', 'TEST-008'],
        linkedMaterialSpecIds: [],
        criticality: 'Critical',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['motor', 'brushless', 'drive']
    },
    {
        id: 7,
        level: 3,
        parentId: 6,
        childIds: [],
        component: 'Motor Bearing',
        partNumber: 'MF-BRG-CER-001',
        description: 'Ceramic ball bearing for motor shaft',
        basicFunction: 'To support motor shaft with low friction',
        quantity: 2,
        material: 'Silicon Nitride Ceramic',
        materialId: 'MAT-CERAMIC-001',
        supplier: 'TurboMotors Ltd',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-11-01',
        linkedFmeaIds: ['FMEA-010'],
        linkedTestIds: ['TEST-BEARING-001'],
        linkedMaterialSpecIds: ['MAT-CERAMIC-001'],
        criticality: 'High',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['bearing', 'ceramic', 'low-noise']
    },
    {
        id: 8,
        level: 2,
        parentId: 3,
        childIds: [],
        component: 'Switch',
        partNumber: 'MF-SW-SEALED-001',
        description: 'Sealed SPST momentary tactile switch',
        basicFunction: 'To open and close electrical circuit',
        quantity: 1,
        material: 'Plastic, Metal',
        supplier: 'ReliableSwitch Corp',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-10-25',
        linkedFmeaIds: ['FMEA-005', 'FMEA-006'],
        linkedTestIds: ['TEST-SWITCH-CYCLE-001'],
        linkedMaterialSpecIds: [],
        criticality: 'High',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['switch', 'sealed', 'tactile']
    },
    {
        id: 9,
        level: 2,
        parentId: 3,
        childIds: [10, 11],
        component: 'Switch Cover Assembly',
        partNumber: 'MF-SWC-001',
        description: 'Sealed switch actuator with gasket',
        basicFunction: 'To actuate switch and prevent liquid ingress',
        quantity: 1,
        material: 'ABS, TPE',
        materialId: 'MAT-ABS-001',
        manufacturingProcess: 'Injection Molding',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-10-28',
        linkedFmeaIds: ['FMEA-007', 'FMEA-008'],
        linkedTestIds: ['TEST-IPX4-001'],
        linkedMaterialSpecIds: ['MAT-ABS-001', 'MAT-TPE-001'],
        criticality: 'Medium',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['switch', 'cover', 'seal']
    },
    {
        id: 10,
        level: 3,
        parentId: 9,
        childIds: [],
        component: 'Switch Gasket',
        partNumber: 'MF-GSK-TPE-001',
        description: 'TPE gasket for switch sealing',
        basicFunction: 'To prevent liquid ingress at switch',
        quantity: 1,
        material: 'TPE (Thermoplastic Elastomer)',
        materialId: 'MAT-TPE-001',
        manufacturingProcess: 'Injection Molding',
        supplier: 'SealMaster Inc',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-10-28',
        linkedFmeaIds: ['FMEA-008'],
        linkedTestIds: ['TEST-IPX4-001'],
        linkedMaterialSpecIds: ['MAT-TPE-001'],
        criticality: 'High',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['gasket', 'seal', 'tpe']
    },
    {
        id: 11,
        level: 3,
        parentId: 9,
        childIds: [],
        component: 'Switch Spring',
        partNumber: 'MF-SPR-SW-001',
        description: 'Return spring for switch button',
        basicFunction: 'To return switch to off position',
        quantity: 1,
        material: 'Stainless Steel Spring Wire',
        manufacturingProcess: 'Coil Winding',
        isValidated: true,
        validationStatus: 'N/A',
        linkedFmeaIds: ['FMEA-007'],
        linkedTestIds: [],
        linkedMaterialSpecIds: [],
        criticality: 'Low',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['spring', 'switch', 'return']
    },
    {
        id: 12,
        level: 2,
        parentId: 3,
        childIds: [],
        component: 'Wire Lead Assembly',
        partNumber: 'MF-WIRE-001',
        description: '18 AWG stranded copper wire with strain relief',
        basicFunction: 'To conduct electrical current',
        quantity: 2,
        material: 'Copper, PVC Insulation',
        manufacturingProcess: 'Wire Extrusion, Assembly',
        isValidated: true,
        validationStatus: 'Passed',
        linkedFmeaIds: ['FMEA-003'],
        linkedTestIds: ['TEST-WIRE-FLEX-001'],
        linkedMaterialSpecIds: [],
        criticality: 'Medium',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['wire', 'conductor', 'flexible']
    },
    {
        id: 13,
        level: 2,
        parentId: 15,
        childIds: [],
        component: 'Drive Shaft',
        partNumber: 'MF-SHAFT-SS304-001',
        description: '304 stainless steel shaft - 3mm diameter, 180mm length',
        basicFunction: 'To transmit torque from motor to whisk head',
        quantity: 1,
        material: '304 Stainless Steel',
        materialId: 'MAT-SS304-001',
        manufacturingProcess: 'Precision Machining',
        supplier: 'PrecisionParts Co',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-11-10',
        linkedFmeaIds: ['FMEA-012', 'FMEA-013'],
        linkedTestIds: ['TEST-SHAFT-STRENGTH-001'],
        linkedMaterialSpecIds: ['MAT-SS304-001'],
        criticality: 'Critical',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['shaft', 'stainless', 'drive']
    },
    {
        id: 14,
        level: 2,
        parentId: 15,
        childIds: [],
        component: 'Whisk Head - Large',
        partNumber: 'MF-WHISK-LG-001',
        description: 'Coiled 304 SS wire - 35mm diameter for better aeration',
        basicFunction: 'To agitate liquid and create foam',
        quantity: 1,
        material: '304 Stainless Steel Wire',
        materialId: 'MAT-SS304-001',
        manufacturingProcess: 'Wire Forming, Welding',
        supplier: 'WhiskWorks Ltd',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-11-12',
        linkedFmeaIds: ['FMEA-014', 'FMEA-015'],
        linkedTestIds: ['TEST-FROTH-PERF-001'],
        linkedMaterialSpecIds: ['MAT-SS304-001'],
        criticality: 'Critical',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['whisk', 'frother', 'large']
    },
    {
        id: 15,
        level: 1,
        parentId: 1,
        childIds: [13, 14, 16, 17],
        component: 'Whisk Assembly',
        partNumber: 'MF-WHISK-ASSY-002',
        description: 'Complete whisk with enhanced sealing',
        basicFunction: 'To create foam through rapid rotation',
        quantity: 1,
        material: 'Multiple',
        manufacturingProcess: 'Sub-assembly',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-11-15',
        linkedFmeaIds: [],
        linkedTestIds: ['TEST-FROTH-PERF-001'],
        linkedMaterialSpecIds: [],
        criticality: 'Critical',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['whisk', 'assembly', 'sealing']
    },
    {
        id: 16,
        level: 2,
        parentId: 15,
        childIds: [],
        component: 'Primary Shaft Seal',
        partNumber: 'MF-SEAL-VITON-001',
        description: 'Viton FKM O-ring - high temperature resistant',
        basicFunction: 'To prevent liquid ingress along shaft',
        quantity: 1,
        material: 'Viton FKM (Fluoroelastomer)',
        materialId: 'MAT-VITON-001',
        supplier: 'AdvancedSeals Inc',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-11-08',
        linkedFmeaIds: ['FMEA-016'],
        linkedTestIds: ['TEST-002', 'TEST-004'],
        linkedMaterialSpecIds: ['MAT-VITON-001'],
        criticality: 'Critical',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['seal', 'viton', 'high-temp']
    },
    {
        id: 17,
        level: 2,
        parentId: 15,
        childIds: [],
        component: 'Secondary Shaft Seal',
        partNumber: 'MF-SEAL-NBR-001',
        description: 'NBR backup O-ring for redundancy',
        basicFunction: 'To provide backup sealing',
        quantity: 1,
        material: 'NBR (Nitrile Rubber)',
        materialId: 'MAT-NBR-001',
        supplier: 'AdvancedSeals Inc',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-11-08',
        linkedFmeaIds: ['FMEA-016'],
        linkedTestIds: ['TEST-002'],
        linkedMaterialSpecIds: ['MAT-NBR-001'],
        criticality: 'High',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['seal', 'backup', 'nbr']
    },
    {
        id: 18,
        level: 2,
        parentId: 3,
        childIds: [],
        component: 'Solder Assembly Points',
        partNumber: 'MF-SOLDER-001',
        description: 'Lead-free solder for wire-to-contact and wire-to-motor joints',
        basicFunction: 'To permanently bond wire leads to contacts and motor terminals',
        quantity: 4,
        material: 'SAC305 Lead-Free Solder',
        materialId: 'MAT-SOLDER-001',
        manufacturingProcess: 'Hand/Wave Soldering',
        supplier: 'SolderTech Co',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-10-05',
        linkedFmeaIds: ['FMEA-003', 'FMEA-006'],
        linkedTestIds: ['TEST-006'],
        linkedMaterialSpecIds: ['MAT-SOLDER-001'],
        criticality: 'Medium',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['solder', 'joint', 'electrical']
    },
    {
        id: 19,
        level: 2,
        parentId: 3,
        childIds: [],
        component: 'Fastener Kit',
        partNumber: 'MF-FAST-001',
        description: 'Self-tapping screws (M2x6) for housing closure, qty 4',
        basicFunction: 'To secure housing halves and retain internal components',
        quantity: 4,
        material: 'Stainless Steel 304',
        manufacturingProcess: 'Cold Heading',
        supplier: 'FastenerWorld Inc',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-09-15',
        linkedFmeaIds: ['FMEA-001', 'FMEA-007'],
        linkedTestIds: ['TEST-001'],
        linkedMaterialSpecIds: [],
        criticality: 'Medium',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['fastener', 'screw', 'housing']
    },
    {
        id: 20,
        level: 1,
        parentId: 1,
        childIds: [],
        component: 'Product Label',
        partNumber: 'MF-LABEL-001',
        description: 'Regulatory compliance and brand label',
        basicFunction: 'To provide product information and compliance markings',
        quantity: 1,
        material: 'UV-Resistant Polymer Film',
        manufacturingProcess: 'Digital Printing',
        supplier: 'LabelPro Inc',
        isValidated: true,
        validationStatus: 'Passed',
        validationDate: '2025-09-30',
        linkedFmeaIds: ['FMEA-020'],
        linkedTestIds: ['TEST-010'],
        linkedMaterialSpecIds: [],
        criticality: 'Medium',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['label', 'compliance', 'branding']
    }
];

// Export count
export const bomSeedDataInfo = {
    totalItems: bomSeedData.length,
    levels: 4,
    criticalComponents: bomSeedData.filter(b => b.criticality === 'Critical').length,
    validatedComponents: bomSeedData.filter(b => b.validationStatus === 'Passed').length,
    generatedDate: '2025-12-12',
    projectName: 'Handheld Milk Frother - Aerator Pro',
    iteration: 17
};

// ============================================
// BOM EVOLUTION BY BUILD STAGE
// ============================================
// Tracks every part introduction, replacement, and obsoletion across
// Alpha → Beta 1 → Beta 2 → C-Level builds

export interface BomEvolutionRecord {
    bomId: number;
    component: string;
    buildStage: 'Alpha' | 'Beta 1' | 'Beta 2' | 'C-Level';
    iterationIntroduced: number;
    dateIntroduced: string;
    action: 'Introduced' | 'Replaced' | 'Material Changed' | 'Obsoleted' | 'Revalidated' | 'Supplier Changed';
    previousConfiguration?: string;
    newConfiguration: string;
    linkedEcnId?: string;
    linkedFmeaIds: string[];
    linkedTestIds: string[];
    designStatus: 'Prototype' | 'In Design' | 'Validated' | 'Production Released';
    ppapStatus: 'Not Started' | 'Planning' | 'Submitted' | 'Approved';
    notes: string;
}

export const bomEvolution: BomEvolutionRecord[] = [
    // ========== ALPHA BUILD (I1-I5) ==========
    {
        bomId: 1,
        component: 'Handheld Milk Frother Assembly',
        buildStage: 'Alpha',
        iterationIntroduced: 1,
        dateIntroduced: '2025-08-01',
        action: 'Introduced',
        newConfiguration: 'AERATOR-MF-2025-V1 — Initial concept assembly, 18 components',
        linkedEcnId: undefined,
        linkedFmeaIds: [],
        linkedTestIds: [],
        designStatus: 'Prototype',
        ppapStatus: 'Not Started',
        notes: 'LLM-generated baseline concept. All components in prototype status.'
    },
    {
        bomId: 2,
        component: 'Main Housing',
        buildStage: 'Alpha',
        iterationIntroduced: 1,
        dateIntroduced: '2025-08-01',
        action: 'Introduced',
        newConfiguration: 'MF-HSG-001-R0 — Standard ABS, no internal fillets',
        linkedEcnId: undefined,
        linkedFmeaIds: ['FMEA-001'],
        linkedTestIds: ['TEST-001'],
        designStatus: 'Prototype',
        ppapStatus: 'Not Started',
        notes: 'Alpha housing. Standard ABS cracked in drop test I1 and I2.'
    },
    {
        bomId: 2,
        component: 'Main Housing',
        buildStage: 'Alpha',
        iterationIntroduced: 5,
        dateIntroduced: '2025-09-15',
        action: 'Material Changed',
        previousConfiguration: 'MF-HSG-001-R0 — Standard ABS',
        newConfiguration: 'MF-HSG-001-R2 — High-Impact ABS (HI-95), internal fillet radii added',
        linkedEcnId: 'ECN-2025-004',
        linkedFmeaIds: ['FMEA-001'],
        linkedTestIds: ['TEST-001'],
        designStatus: 'Validated',
        ppapStatus: 'Planning',
        notes: 'Material upgrade resolved drop test failures. I5 passed all 6 drops.'
    },
    {
        bomId: 4,
        component: 'Battery Contact Spring (+)',
        buildStage: 'Alpha',
        iterationIntroduced: 1,
        dateIntroduced: '2025-08-01',
        action: 'Introduced',
        newConfiguration: 'MF-BCS-001 — Bare spring steel, no plating',
        linkedEcnId: undefined,
        linkedFmeaIds: ['FMEA-004'],
        linkedTestIds: ['TEST-007'],
        designStatus: 'Prototype',
        ppapStatus: 'Not Started',
        notes: 'Alpha contacts. Bare steel corroded badly in salt spray test I1 (4.7Ω).'
    },
    {
        bomId: 4,
        component: 'Battery Contact Spring (+)',
        buildStage: 'Alpha',
        iterationIntroduced: 3,
        dateIntroduced: '2025-08-20',
        action: 'Material Changed',
        previousConfiguration: 'Bare spring steel',
        newConfiguration: 'MF-BCS-001 — Nickel-plated spring steel (5-10 μm)',
        linkedEcnId: 'ECN-2025-002',
        linkedFmeaIds: ['FMEA-004'],
        linkedTestIds: ['TEST-007'],
        designStatus: 'Validated',
        ppapStatus: 'Planning',
        notes: 'Nickel plating resolved corrosion. I3 salt spray passed (0.15Ω).'
    },
    {
        bomId: 5,
        component: 'Battery Contact Plate (-)',
        buildStage: 'Alpha',
        iterationIntroduced: 3,
        dateIntroduced: '2025-08-20',
        action: 'Material Changed',
        previousConfiguration: 'Bare steel plate',
        newConfiguration: 'MF-BCP-001 — Nickel-plated steel',
        linkedEcnId: 'ECN-2025-002',
        linkedFmeaIds: ['FMEA-004'],
        linkedTestIds: ['TEST-007'],
        designStatus: 'Validated',
        ppapStatus: 'Planning',
        notes: 'Plating upgrade applied at same time as positive contact.'
    },
    {
        bomId: 12,
        component: 'Wire Lead Assembly',
        buildStage: 'Alpha',
        iterationIntroduced: 2,
        dateIntroduced: '2025-08-10',
        action: 'Replaced',
        previousConfiguration: 'MF-WIRE-001-R0 — No strain relief, sharp housing exit',
        newConfiguration: 'MF-WIRE-001 — Added molded strain relief at housing exit',
        linkedEcnId: 'ECN-2025-001',
        linkedFmeaIds: ['FMEA-003'],
        linkedTestIds: ['TEST-003'],
        designStatus: 'Validated',
        ppapStatus: 'Not Started',
        notes: 'Strain relief resolved wire flex failure. Went from 3,200 to 10,000+ cycles.'
    },
    {
        bomId: 13,
        component: 'Drive Shaft',
        buildStage: 'Alpha',
        iterationIntroduced: 4,
        dateIntroduced: '2025-09-01',
        action: 'Material Changed',
        previousConfiguration: 'Generic carbon steel shaft',
        newConfiguration: 'MF-SHAFT-SS304-001 — 304 Stainless Steel, FDA compliant',
        linkedEcnId: 'ECN-2025-003',
        linkedFmeaIds: ['FMEA-012', 'FMEA-015'],
        linkedTestIds: ['TEST-008'],
        designStatus: 'Validated',
        ppapStatus: 'Planning',
        notes: 'Food safety requirement. 304 SS certified per FDA CFR 177.2750.'
    },
    {
        bomId: 14,
        component: 'Whisk Head',
        buildStage: 'Alpha',
        iterationIntroduced: 1,
        dateIntroduced: '2025-08-01',
        action: 'Introduced',
        newConfiguration: 'MF-WHISK-SM-001 — 20mm diameter, 304 SS wire',
        linkedEcnId: undefined,
        linkedFmeaIds: ['FMEA-014'],
        linkedTestIds: ['TEST-009'],
        designStatus: 'Prototype',
        ppapStatus: 'Not Started',
        notes: 'Alpha small whisk. Too small for adequate frothing (52s, 165ml).'
    },

    // ========== BETA 1 BUILD (I6-I10) ==========
    {
        bomId: 16,
        component: 'Primary Shaft Seal',
        buildStage: 'Beta 1',
        iterationIntroduced: 6,
        dateIntroduced: '2025-09-25',
        action: 'Material Changed',
        previousConfiguration: 'Silicone O-ring — failed at 80°C hot liquid',
        newConfiguration: 'MF-SEAL-VITON-001 — Viton FKM O-ring, rated to 200°C',
        linkedEcnId: 'ECN-2025-005',
        linkedFmeaIds: ['FMEA-016'],
        linkedTestIds: ['TEST-002'],
        designStatus: 'Validated',
        ppapStatus: 'Planning',
        notes: 'CRITICAL FIX. Silicone failed completely in hot milk. Viton passed.'
    },
    {
        bomId: 10,
        component: 'Switch Gasket',
        buildStage: 'Beta 1',
        iterationIntroduced: 7,
        dateIntroduced: '2025-10-01',
        action: 'Material Changed',
        previousConfiguration: 'Silicone gasket — poor compression set, IPX4 failed',
        newConfiguration: 'MF-GSK-TPE-001 — TPE gasket, better compression recovery',
        linkedEcnId: 'ECN-2025-006',
        linkedFmeaIds: ['FMEA-008'],
        linkedTestIds: ['TEST-004'],
        designStatus: 'Validated',
        ppapStatus: 'Planning',
        notes: 'IPX4 compliance achieved with TPE gasket swap.'
    },
    {
        bomId: 14,
        component: 'Whisk Head',
        buildStage: 'Beta 1',
        iterationIntroduced: 9,
        dateIntroduced: '2025-10-18',
        action: 'Replaced',
        previousConfiguration: 'MF-WHISK-SM-001 — 20mm small whisk → OBSOLETED',
        newConfiguration: 'MF-WHISK-LG-001 — 35mm large whisk for better aeration',
        linkedEcnId: 'ECN-2025-008',
        linkedFmeaIds: ['FMEA-014'],
        linkedTestIds: ['TEST-009'],
        designStatus: 'Validated',
        ppapStatus: 'Planning',
        notes: 'Performance jumped from 52s/165ml to 25s/220ml. Old 20mm whisk obsoleted.'
    },
    {
        bomId: 17,
        component: 'Secondary Shaft Seal',
        buildStage: 'Beta 1',
        iterationIntroduced: 10,
        dateIntroduced: '2025-10-30',
        action: 'Introduced',
        newConfiguration: 'MF-SEAL-NBR-001 — NBR backup O-ring for redundancy',
        linkedEcnId: 'ECN-2025-010',
        linkedFmeaIds: ['FMEA-016'],
        linkedTestIds: ['TEST-002'],
        designStatus: 'Validated',
        ppapStatus: 'Planning',
        notes: 'NEW PART. Added backup seal to eliminate single point of failure.'
    },

    // ========== BETA 2 BUILD (I11-I14) ==========
    {
        bomId: 7,
        component: 'Motor Bearing',
        buildStage: 'Beta 2',
        iterationIntroduced: 11,
        dateIntroduced: '2025-10-22',
        action: 'Material Changed',
        previousConfiguration: 'Steel ball bearings — Noise 72-78 dB',
        newConfiguration: 'MF-BRG-CER-001 — Silicon Nitride ceramic bearings, 55 dB',
        linkedEcnId: 'ECN-2025-009',
        linkedFmeaIds: ['FMEA-010'],
        linkedTestIds: ['TEST-010'],
        designStatus: 'Validated',
        ppapStatus: 'Submitted',
        notes: '40% noise reduction. Customer delighted with quieter operation.'
    },
    {
        bomId: 6,
        component: 'DC Motor',
        buildStage: 'Beta 2',
        iterationIntroduced: 12,
        dateIntroduced: '2025-10-25',
        action: 'Replaced',
        previousConfiguration: 'MF-MOT-001 — Brushed DC, 12000 RPM, brush wear at 85%@100h',
        newConfiguration: 'MF-MOT-HC-002 — Brushless DC, 15000 RPM, >200h life, integrated ceramic bearings',
        linkedEcnId: 'ECN-2025-011',
        linkedFmeaIds: ['FMEA-009', 'FMEA-010', 'FMEA-011'],
        linkedTestIds: ['TEST-005', 'TEST-006'],
        designStatus: 'Validated',
        ppapStatus: 'Submitted',
        notes: 'MAJOR UPGRADE. Brush wear failure mode eliminated. 75% RPN reduction on FMEA-011.'
    },
    {
        bomId: 6,
        component: 'DC Motor',
        buildStage: 'Beta 2',
        iterationIntroduced: 12,
        dateIntroduced: '2025-11-01',
        action: 'Supplier Changed',
        previousConfiguration: 'Generic motor supplier',
        newConfiguration: 'TurboMotors Ltd — Premium grade brushless with integrated ceramic bearings',
        linkedEcnId: 'ECN-2025-011',
        linkedFmeaIds: ['FMEA-009'],
        linkedTestIds: ['TEST-006'],
        designStatus: 'Validated',
        ppapStatus: 'Submitted',
        notes: 'Qualified TurboMotors as single-source premium supplier.'
    },

    // ========== C-LEVEL BUILD (I15-I17) ==========
    {
        bomId: 13,
        component: 'Drive Shaft',
        buildStage: 'C-Level',
        iterationIntroduced: 15,
        dateIntroduced: '2025-11-20',
        action: 'Revalidated',
        newConfiguration: 'MF-SHAFT-SS304-001 — Controlled press-fit procedure added (500-800N)',
        linkedEcnId: 'ECN-2025-012',
        linkedFmeaIds: ['FMEA-013'],
        linkedTestIds: ['TEST-011'],
        designStatus: 'Production Released',
        ppapStatus: 'Approved',
        notes: 'Pneumatic press with force monitoring. Pull force Cpk=1.67. Process locked.'
    },
    {
        bomId: 20,
        component: 'Product Label',
        buildStage: 'C-Level',
        iterationIntroduced: 16,
        dateIntroduced: '2025-12-01',
        action: 'Introduced',
        newConfiguration: 'MF-LABEL-001 — CE/UL/FDA markings, UV-resistant polymer film',
        linkedEcnId: undefined,
        linkedFmeaIds: ['FMEA-020'],
        linkedTestIds: ['TEST-LABEL-DURABILITY-001'],
        designStatus: 'Production Released',
        ppapStatus: 'Approved',
        notes: 'Regulatory labels added for production. Label adhesion tested per ASTM D3359.'
    },
    {
        bomId: 18,
        component: 'Solder Assembly Points',
        buildStage: 'C-Level',
        iterationIntroduced: 15,
        dateIntroduced: '2025-11-20',
        action: 'Introduced',
        newConfiguration: 'MF-SOLDER-001 — SAC305 Lead-Free solder, 4 joints per unit',
        linkedEcnId: undefined,
        linkedFmeaIds: ['FMEA-003', 'FMEA-006'],
        linkedTestIds: ['TEST-ELECT-001'],
        designStatus: 'Production Released',
        ppapStatus: 'Approved',
        notes: 'Formalized solder spec for production. RoHS compliant.'
    },
    {
        bomId: 19,
        component: 'Fastener Kit',
        buildStage: 'C-Level',
        iterationIntroduced: 15,
        dateIntroduced: '2025-11-20',
        action: 'Introduced',
        newConfiguration: 'MF-FAST-001 — M2x6 SS304 self-tapping screws, qty 4',
        linkedEcnId: undefined,
        linkedFmeaIds: ['FMEA-001', 'FMEA-007'],
        linkedTestIds: ['TEST-001'],
        designStatus: 'Production Released',
        ppapStatus: 'Approved',
        notes: 'Replaced snap-fit with screws for serviceability. Torque spec: 0.3 Nm.'
    },
    {
        bomId: 1,
        component: 'Handheld Milk Frother Assembly',
        buildStage: 'C-Level',
        iterationIntroduced: 17,
        dateIntroduced: '2025-12-12',
        action: 'Revalidated',
        newConfiguration: 'AERATOR-MF-2025-V17 — Production release, 20 components, all validated',
        linkedEcnId: undefined,
        linkedFmeaIds: [],
        linkedTestIds: [],
        designStatus: 'Production Released',
        ppapStatus: 'Approved',
        notes: 'FINAL RELEASE. Zero defects in 50-unit pilot build. Full PPAP approved.'
    }
];

// BOM Evolution Summary
export const bomEvolutionSummary = {
    totalEvolutionRecords: bomEvolution.length,
    byBuildStage: {
        Alpha: bomEvolution.filter(e => e.buildStage === 'Alpha').length,
        'Beta 1': bomEvolution.filter(e => e.buildStage === 'Beta 1').length,
        'Beta 2': bomEvolution.filter(e => e.buildStage === 'Beta 2').length,
        'C-Level': bomEvolution.filter(e => e.buildStage === 'C-Level').length
    },
    byAction: {
        Introduced: bomEvolution.filter(e => e.action === 'Introduced').length,
        Replaced: bomEvolution.filter(e => e.action === 'Replaced').length,
        'Material Changed': bomEvolution.filter(e => e.action === 'Material Changed').length,
        'Supplier Changed': bomEvolution.filter(e => e.action === 'Supplier Changed').length,
        Revalidated: bomEvolution.filter(e => e.action === 'Revalidated').length
    },
    obsoletedParts: [
        { part: 'MF-WHISK-SM-001 (20mm small whisk)', replacedBy: 'MF-WHISK-LG-001 (35mm)', atIteration: 9 },
        { part: 'MF-MOT-001 (Brushed DC motor)', replacedBy: 'MF-MOT-HC-002 (Brushless DC)', atIteration: 12 },
        { part: 'Silicone shaft seal', replacedBy: 'MF-SEAL-VITON-001 (Viton FKM)', atIteration: 6 },
        { part: 'Steel ball bearings', replacedBy: 'MF-BRG-CER-001 (Ceramic)', atIteration: 11 },
        { part: 'Bare steel contacts', replacedBy: 'Nickel-plated contacts', atIteration: 3 },
        { part: 'Silicone switch gasket', replacedBy: 'MF-GSK-TPE-001 (TPE)', atIteration: 7 }
    ],
    ppapStatusSummary: {
        approved: bomEvolution.filter(e => e.ppapStatus === 'Approved').length,
        submitted: bomEvolution.filter(e => e.ppapStatus === 'Submitted').length,
        planning: bomEvolution.filter(e => e.ppapStatus === 'Planning').length,
        notStarted: bomEvolution.filter(e => e.ppapStatus === 'Not Started').length
    }
};
